import axios from "axios"
import { GetLoginTailInterface } from "types/loginTrail.types"

const ROOT_PATH = "login-trail"

export default class LoginTrailService {
	static getLoginTrail = (user: string) => axios.get<GetLoginTailInterface[]>(`${ROOT_PATH}/${user}`)
}
